'use strict';
{
    var app = angular.module('tf.home', [])
        .controller('exercisedPositionsCtrl', ['$scope', '$http', function($scope, $http) {
            $scope.exercisedPositions = null;
            $http.get('/tradefloor/api/positions/exercised').then(function(result) {
                var data = result.data;
                $scope.exercisedPositions = data;
            })
        }])
        .controller('homeCtrl', ['$scope', '$state', '$http', '$stateParams', 'userConfig', '$filter', 'terms', '$uibModal', '$localStorage', '$window', function homeController($scope, $state, $http, $stateParams, userConfig, $filter, terms, $uibModal, $localStorage, $window) {
            $scope.xjoData = [];
            $scope.xjoDates = [];
            $scope.xjoChangePts = 0;
            $scope.xjoChangePct = 0;

            $scope.openIress = function () {

                var modalInstance = $uibModal.open({
                    templateUrl: 'app/home/partials/iress.tpl.html',
                    windowClass: 'margin-top50 inviteClient',
                    size: 'md',
                    controller : 'iressCtrl'
                });
            };

            $state.userConfig = userConfig;

            $scope.openInterestChart = 'change';

            $scope.xjoHistoryOptions = {
                type:'line',
                width:'55%',
                height:'100px',
                fillColor : false,
                minSpotColor: "#A90329",
                maxSpotColor: "green",
                lineColor : 'grey',
                lineWidth : 2,
                spotRadius : 2.5,
                spotColor: '#7f7f7f',
                highlightSpotColor: '#333333',
                highlightLineColor: '#333333',
                tooltipFormatter : function(sparkline, options, fields) {
                    return '<div class="jqsfield">' + $filter('date')($scope.xjoDates[fields.x], 'EEE dd/MM') + ' <br> ' + $filter('points')(fields.y, 2) + '</div>';
                }
            };

            var defaultStorage = {};

            defaultStorage.homeTour = {
                complete : false,
                skipped : false
            };

            $scope.$storage = $localStorage.$default(defaultStorage);

            $scope.openInterestOvernightOptions = {
                chart: {
                    type: 'multiBarHorizontalChart',
                    height: 480,
                    margin : {
                        top: 20,
                        right: 20,
                        bottom: 20,
                        left: 50
                    },
                    x: function(d){return d[0];},
                    y: function(d){return d[1];},
                    showControls: false,
                    showValues: false,
                    transitionDuration: 750,
                    stacked: false,
                    xAxis: {
                        showMaxMin: false
                    },
                    yAxis: {
                        axisLabel: 'Values',
                        tickFormat: function(d){
                            return d3.format(',.2f')(d);
                        },
                        highlightZero: false
                    }
                }
            };

            $http.get('/tradefloor/api/open_interest/overnight', {}).then(function(resp) {
                var data = resp.data;

                $scope.openInterestAsAt = data.businessDate;


                var movers = data.underlyings
                    .map(function (value) {
                        var changePuts = value.puts - value.prevPuts;
                        var changeCalls = value.calls - value.prevCalls;
                        var absChange = Math.abs(changePuts) + Math.abs(changeCalls);

                        return {
                            underlying : value.underlying,
                            puts : value.puts,
                            changePuts : changePuts,
                            calls : value.calls,
                            changeCalls : changeCalls,
                            absChange : absChange,
                            netPosition : value.calls - value.puts
                        };
                    })
                    .sort(function (a, b) {
                        if (a.absChange < b.absChange) {
                            return 1;
                        }
                        if (a.absChange > b.absChange) {
                            return -1;
                        }

                        return 0;
                    })
                    .slice(0, 10);

                var puts = movers.map(function(value) {
                    return [value.underlying, - value.puts]
                });

                var calls = movers.map(function(value) {
                    return [value.underlying, value.calls]
                });

                var changePuts = movers.map(function(value) {
                    return [value.underlying, value.changePuts]
                });

                var changeCalls = movers.map(function(value) {
                    return [value.underlying, value.changeCalls]
                });

                var netPuts = movers.map(function(value) {
                    return [value.underlying, Math.min(0, value.netPosition)]
                });

                var netCalls = movers.map(function(value) {
                    return [value.underlying, Math.max(0, value.netPosition)]
                });

                $scope.openInterest = [
                    { key:"Put", values: puts},
                    { key:"Call", values: calls }
                    ];

                $scope.openInterestOvernight = [
                        { key:"Put", values: changePuts},
                        { key:"Call", values: changeCalls }
                    ];

                $scope.openInterestNetChanges = [
                    { key:"Put", values: netPuts},
                    { key:"Call", values: netCalls }
                ];
            });

            $scope.getData = function() {
                $http.get('/tradefloor/api/prices/chart/XJO?r=30d').then(function(response) {
                    Papa.parse(response.data, {
                        download: false,
                        complete: function (results) {
                            results.data.shift(); // Remove header

                            var priceData = results.data
                                                   .filter(function (row) {
                                                       return row[0];

                                                   }).map(function (row) {
                                    return {
                                        date: row[0],
                                        open: parseFloat(row[1]),
                                        high: parseFloat(row[2]),
                                        low: parseFloat(row[3]),
                                        close: parseFloat(row[4])
                                    }
                            });

                            $scope.xjoData = priceData.map(function(d) {return d.close});
                            $scope.xjoDates = priceData.map(function(d) {return new Date(d.date)});

                            $scope.lastClose = $scope.xjoData[$scope.xjoData.length - 1];
                            $scope.prevClose = $scope.xjoData[$scope.xjoData.length - 2];

                            $scope.xjoChangePts = $scope.lastClose - $scope.prevClose;
                            $scope.xjoChangePct = $scope.xjoChangePts / $scope.prevClose;

                            $scope.xjoAsAt = new Date();
                        }
                    });

                });
            };

            $scope.getData();


            $scope.onFinishTour = function(completed) {
                $scope.$storage.homeTour.complete = true;
                $scope.$storage.homeTour.skipped = !completed;
            };

            $scope.ngJoyrideHomeConfig = [];

            function setupJoyride() {
                //var scratch = $scope.portfolio.scratch;
                $scope.ngJoyrideHomeConfig = [];

                if ($scope.userConfig.client) {
                    $scope.ngJoyrideHomeConfig.push({
                        type: "title",
                        heading: "Welcome to {TradeFloor}",
                        text: '<span>This tutorial is designed to help you get up to speed with {TradeFloor} in under 5 minutes.</span><br><br>' +
                        '<a href="http://support.tradefloor.com.au/faq/getting-started-video/" target="_blank"><img src="https://tradefloor.com.au/tradefloor/email_assets/videos/introClient.jpg" width="100%" height="auto" border="0" alt="{TradeFloor} introduction video" style="display: block; padding: 0; color: #666666; text-decoration: none;" ></a>'

                    });
                }

                if (!$scope.userConfig.client) {
                    $scope.ngJoyrideHomeConfig.push({
                        type: "title",
                        heading: "Welcome to {TradeFloor}",
                        text: '<span>This tutorial is designed to help you get up to speed with {TradeFloor} in under 5 minutes.</span>'

                    });
                }

                $scope.ngJoyrideHomeConfig.push({
                    type: "element",
                    selector: "#left-menu",
                    text: "This is the main navigation menu, where you can switch between different areas of the application.",
                    placement: "right",
                    scroll: true
                    });

                    if ($window.innerWidth > 768) {

                        $scope.ngJoyrideHomeConfig.push({
                            type: "element",
                            selector: "#xjoPrice",
                            text: "The closing price of XJO from the previous trading session, as well as a reference chart of the activity over the last 30 days.",
                            placement: "left",
                        scroll: true
                    });

                    $scope.ngJoyrideHomeConfig.push({
                        type: "element",
                        selector: "#myWatchlist",
                        text: "The watchlist is pre-filled with the top 10 holdings across all of your accounts, and will show the latest prices available in TradeFloor.",
                        placement: "left",
                        scroll: true
                    });

//                     $scope.ngJoyrideHomeConfig.push({
//                         type: "element",
//                         selector: "#openInterest",
//                         text: "The overnight change in Open Interest, sorted by largest net change day-on-day. You can also view the largest open interest, and the net open interest (calls less puts) by clicking on the drop-down",
//                         placement: "left",
//                         scroll: true
//                     });
                }

                if ($window.innerWidth <= 768) {
                    $scope.ngJoyrideHomeConfig.push({
                        type: "element",
                        selector: "#xjoPrice",
                        text: "The closing price of XJO from the previous trading session, as well as a reference chart of the activity over the last 30 days.",
                        placement: "bottom",
                        scroll: true
                    });

                    $scope.ngJoyrideHomeConfig.push({
                        type: "element",
                        selector: "#myWatchlist",
//                heading: "Title can have <em>HTML</em>",
                        text: "The watchlist is pre-filled with the top 10 holdings across all of your accounts, and will show the latest prices available in TradeFloor.",
                        placement: "top",
                        scroll: true
                    });

//                     $scope.ngJoyrideHomeConfig.push({
//                         type: "element",
//                         selector: "#openInterest",
// //                heading: "Title can have <em>HTML</em>",
//                         text: "The overnight change in Open Interest, sorted by largest net change day-on-day. You can also change the view to display largest open interest, and the net open interest.",
//                         placement: "top",
//                         scroll: true
//                     });
                }

            }

            setupJoyride();
            $scope.startJoyRide = false;

            $state.current.data.startTour = function() {
                $scope.startJoyRide = true;
            };
        }])

        .controller('iressCtrl', ['$scope', '$uibModalInstance', function iressController ($scope, $uibModalInstance) {
            $scope.iress = {
                user : null,
                password : null
            };

            $scope.ok = function () {
                $uibModalInstance.close($scope.feedSource);
            };

            $scope.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }])
        ;
}







